import { render, staticRenderFns } from "./ReadingCountOfPatients.vue?vue&type=template&id=ea2510e2&scoped=true&"
import script from "./ReadingCountOfPatients.vue?vue&type=script&lang=js&"
export * from "./ReadingCountOfPatients.vue?vue&type=script&lang=js&"
import style0 from "./ReadingCountOfPatients.vue?vue&type=style&index=0&id=ea2510e2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea2510e2",
  null
  
)

export default component.exports